import UpperHighlight from './UpperHighlight';
import LowerHighlight from './LowerHighlight';

export { UpperHighlight, LowerHighlight };
